import { ColumnType } from "../../types/dataGridTypes";

const useAccessionColumns = () => {
  const values: any = [{ value: "In Progress", label: "In Progress" }];
  const accessionListColumns: ColumnType[] = [
    {
      field: "accession_id",
      headerName: "Accession ID",
      minWidth: 140,
      flex: 1,
      cmp: "link",
      linkPermission: "VIEW_STUDY_DETAILS",
      badge: true,
    },
    {
      field: "created",
      headerName: "Created Date",
      width: 100,
    },
    {
      field: "studyID",
      headerName: "Study ID",
      minWidth: 160,
      flex: 1,
      cmp: "link",
      linkPermission: "VIEW_STUDY_DETAILS",
    },
    {
      field: "assessmentPlan",
      headerName: "Assessment Plan",
      minWidth: 200,
      flex: 1,
      cmp: "link",
      linkPermission: "VIEW_STUDY_DETAILS",
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 100,
      type: "singleSelect",
      valueOptions: values,
      cmp: "chip",
    },
    {
      field: "lastupdate",
      headerName: "Last Updated",
      width: 140,
    },
    {
      field: "actionsColumn",
      width: 90,
      type: "actions",
      cmp: "actions",
      headerName: "Action",
      sortable: false,
      filterable: false,
      actionsArray: [
        { icon: "Edit", label: "Edit", key: "action_edit" },
        { icon: "Delete", label: "Delete", key: "action_delete" },
      ],
    },
  ];
  return accessionListColumns;
};

export default useAccessionColumns;
